export function funcify<T = unknown>(
  maybeFunction: Callable<unknown[], T> | T,
): Callable<unknown[], T> {
  if (typeof maybeFunction === 'function') {
    return maybeFunction as Callable<unknown[], T>;
  }

  return () => maybeFunction;
}
